import { validateSchema } from 'straightline-utils/hooks';

export default {
  before: {
    create: [validateSchema]
  },
  after: {
    create: []
  },
  error: {
    create: []
  }
};
